import { CheerzApiHeaderCategory, CheerzApiHeaderSubCategory } from "@Types/api/header";
import { Category, SubCategory } from "@Types/header";

export function convertHeaderCategoriesFromApiToContent(
  jsonContent: CheerzApiHeaderCategory[]
): Category[] {
  const headerCategories: Category[] = jsonContent.map((categoryContent) => {
    let headerCategory: Category = {
      assetHighlights: categoryContent.asset_highlights.map((assetHighlight) => {
        return {
          images: assetHighlight.images,
          subTitle: assetHighlight.description,
          tag: assetHighlight.tag,
          title: assetHighlight.title,
        };
      }),
      featured: categoryContent.featured,
      id: categoryContent.id,
      linkText: categoryContent.link_text,
      partnershipHighlights: categoryContent.partnership_highlights.map((partnershipHighlight) => {
        return {
          images: partnershipHighlight.images,
          subTitle: partnershipHighlight.description,
          tag: partnershipHighlight.tag,
          title: partnershipHighlight.title,
          url: partnershipHighlight.url,
        };
      }),
      priority: categoryContent.priority,
      productHighlights: categoryContent.product_highlights.map((productHighlight) => {
        return {
          images: productHighlight.images,
          subTitle: productHighlight.excerpt,
          tag: productHighlight.tag,
          title: productHighlight.name,
          url: productHighlight.url,
        };
      }),
      subCategories: convertSubCategoriesFromApiToContent(categoryContent.sub_categories),
      tag: categoryContent.tag,
      title: categoryContent.name,
      url: categoryContent.url,
    };
    if (categoryContent.featured) {
      headerCategory = {
        ...headerCategory,
        color: categoryContent.background_color,
      };
    }
    return headerCategory;
  });

  return headerCategories;
}

export const convertSubCategoriesFromApiToContent = (
  subCategories: CheerzApiHeaderSubCategory[]
): SubCategory[] => {
  return subCategories.map((subCategory) => {
    return {
      priority: subCategory.priority,
      productPages: subCategory.pages.map((productPage) => {
        return {
          label: productPage.label,
          labelColor: productPage.label_color,
          starred: productPage.starred,
          tag: productPage.tag,
          title: productPage.title,
          url: productPage.url,
        };
      }),
      title: subCategory.title,
    };
  });
};
